import * as React from 'react';
import classNames from 'classnames';
import { LinkHelper } from '../../routes';
import Button from './Button';
const styles = require('./Button.less') as any;

const LinkButton = (({kind='primary', to, children, ...props}) => (
		<LinkHelper to={to} {...props}>
				<Button className={classNames(styles.button, styles[kind])}>{children}</Button>
		</LinkHelper>
)) as any;

export default LinkButton;



// WEBPACK FOOTER //
// ./src/app/components/Button/LinkButton.tsx